import { useRef, useState } from 'react';
import useClickOutside from '../../hooks/useClickOutside';
import usePressEsc from '../../hooks/usePressEsc';
import './WorkspaceDropdown.scss';
import { t } from '../../i18n/i18n';
import ArrowDropdown from '../../assets/dashboard/ArrowDropdown';
import ModalCustom from '../ModalCustom/ModalCustom';
import { determineIconType } from '../../utils/determineIconWorkspace/determineIconWorkspace';
import { addTruncate } from '../../utils/addTruncate';
import useDropdownAnimation from '../../hooks/useDropdownAnimation';
import { useWorkspaceManager } from '../../hooks/useWorkspaceManager';
import WorkspaceDropdownContent from '../WorkspaceDropdownContent/WorkspaceDropdownContent';

const WorkspaceDropdown = ({
  className,
  collapsed,
  limit = true,
  noLogo = false,
  customBackground = false,
}) => {
  const workspaceManager = useWorkspaceManager();
  const [open, setOpen] = useState(false);
  const { visible, animationClass, handleToggle, handleClose } = useDropdownAnimation(
    open,
    setOpen,
    'dropdown-workspace-enter',
    'dropdown-workspace-exit'
  );

  const ref = useRef(null);
  useClickOutside(ref, () => handleClose());

  usePressEsc(() => handleClose());

  return (
    <div
      className={`ml-2 d-flex align-self-end align-self-sm-center dropdown-workspace-max-height ${
        open && 'dropdown-workspace-container-index'
      }`}
    >
      {workspaceManager.showModalAddWorkspace && (
        <ModalCustom
          datatestid="modal-create-workspace"
          datatestidbuttonok="button-ok"
          title={t('CREATE_WORKSPACE')}
          htmlSubtitle
          show={workspaceManager.showModalAddWorkspace}
          setShow={workspaceManager.setShowModalAddWorkspace}
          onOkText={t('CREATE')}
          onCancelText={t('CANCEL')}
          onCancel={() => workspaceManager.setShowModalAddWorkspace(false)}
          onOk={workspaceManager.handleCreateWorkspace}
          classModal="modal-create-workspace"
          showCross={false}
          isLoading={workspaceManager.createWorkspaceLoader}
          input={
            <input
              ref={(ref) => ref && ref.focus()}
              className="input-name-workspace input outline-none px-3 py-2  input-search text-base mx-auto mt-3 mb-2"
              onChange={(e) => workspaceManager.setWorkspaceName(e.target.value)}
              type="text"
              value={workspaceManager.workspaceName}
              placeholder={t('CREATE_WORKSPACE_INPUT_NAME')}
            />
          }
        />
      )}
      <div
        ref={ref}
        className={`rounded  font-weight-bold non-selectable dropdown-workspace-select-container b-radius-8 position-relative ${className} ${
          !collapsed && 'width-button-open'
        } ${customBackground && 'dropdown-custom-background'}`}
      >
        <div
          onClick={handleToggle}
          aria-hidden
          className={`cursor-pointer p-2 d-flex align-items-center ${limit && 'w-100'}`}
        >
          {!noLogo && determineIconType(workspaceManager.workspaceInfo)}
          {!collapsed && (
            <>
              <span
                data-testid="name-workspace-placeholder"
                className="text-white  overflow-hidden ml-2 mr-1 text-xs"
              >
                {limit
                  ? addTruncate(workspaceManager.workspaceInfo.placeholder, 14)
                  : workspaceManager.workspaceInfo?.placeholder ?? ''}
              </span>
              <div
                className={`${
                  open ? 'dropdown-workspace-select-arrow-open' : 'dropdown-workspace-select-arrow'
                }`}
              >
                <ArrowDropdown />
              </div>
            </>
          )}
        </div>
        {visible && (
          <WorkspaceDropdownContent
            worskpacesListFilter={workspaceManager.worskpacesListFilter}
            searchWorkspace={workspaceManager.searchWorkspace}
            setSearchWorkspace={workspaceManager.setSearchWorkspace}
            setWorkspace={workspaceManager.setWorkspace}
            addFavorite={workspaceManager.addFavorite}
            removeFavorite={workspaceManager.removeFavorite}
            createWorkspace={workspaceManager.createWorkspace}
            redirectToConfig={workspaceManager.redirectToConfig}
            dropdownClassName={`${!limit && 'w-25'} ${
              collapsed ? 'workspace-dropdown-collapsed' : ''
            } overflow-auto m-0 z-index-10 ${animationClass}`}
            onClose={handleClose}
            variant="sidebar"
            currentWorkspaceId={workspaceManager.currentWorkspace}
          />
        )}
      </div>
    </div>
  );
};

export default WorkspaceDropdown;
